import { useTranslation } from 'react-i18next'

interface SkeletonProps {
  readonly className?: string
}

/**
 * Bloc de remplacement pendant un chargement. Il est masqué aux lecteurs
 * d'écran : c'est le conteneur `SkeletonList` qui annonce l'attente, une fois,
 * plutôt que chaque barre.
 */
export function Skeleton({ className = '' }: SkeletonProps) {
  return (
    <div
      aria-hidden="true"
      className={`animate-pulse rounded-2xl bg-surface-container ${className}`}
    />
  )
}

interface SkeletonListProps {
  readonly rows?: number
  readonly rowClassName?: string
  readonly className?: string
}

/**
 * Plusieurs blocs et une annonce unique. Sans `role="status"`, un lecteur
 * d'écran ne dirait rien pendant le chargement : l'utilisateur croirait la page
 * vide.
 */
export function SkeletonList({
  rows = 3,
  rowClassName = 'h-16',
  className = 'flex flex-col gap-3',
}: SkeletonListProps) {
  const { t } = useTranslation()

  return (
    <div role="status" aria-label={t('common.loading_label')} className={className}>
      {Array.from({ length: rows }, (_, index) => (
        <Skeleton key={`skeleton-${index}`} className={rowClassName} />
      ))}
    </div>
  )
}
